import { ReactNode } from "react";
import { Paper, PaperProps } from "@mui/material";

interface AuthPaperProps extends Omit<PaperProps, "children"> {
  children: ReactNode;
  maxWidth?: number;
}

const AuthPaper = ({
  children,
  maxWidth = 480,
  sx,
  ...props
}: AuthPaperProps) => {
  return (
    <Paper
      data-testid="auth-paper"
      elevation={16}
      sx={{
        borderRadius: "10px",
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        maxWidth,
        width: "100%",
        zIndex: 1,
        backgroundColor: "rgb(24 18 26 / 92%)",
        backgroundImage: "unset",
        border: `2px solid rgba(210, 100, 21, 0.3)}`,
        boxShadow: `0 0 20px 8px rgba(210, 100, 21, 0.3)`,
        "@media (max-width: 500px)": {
          "& .MuiPaper-elevation": {
            maxWidth: 360,
          },
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default AuthPaper;
